import React from "react";
import { api } from "../../lib/api";
import { Loader2, Save } from "lucide-react";

const FIELDS = [
  ["studio_name", "Nom du studio"], ["instagram_handle", "Compte Instagram"], ["location", "Localisation"],
  ["tone", "Ton de voix", true], ["audience", "Public cible", true], ["values", "Valeurs", true],
  ["words_to_avoid", "Mots à éviter"], ["default_cta", "Appel à l'action par défaut"], ["preferred_times", "Horaires préférés"],
];

export const BrandProfileForm = ({ onClose }) => {
  const [brand, setBrand] = React.useState(null);
  const [saving, setSaving] = React.useState(false);
  const [msg, setMsg] = React.useState("");
  React.useEffect(() => { api.get("/admin/marketing/brand").then((r) => setBrand(r.data)); }, []);
  const set = (k, v) => setBrand((b) => ({ ...b, [k]: v }));
  const save = async () => {
    setSaving(true); setMsg("");
    try { await api.put("/admin/marketing/brand", brand); setMsg("Profil enregistré."); }
    catch (e) { setMsg(e.response?.data?.detail?.[0]?.msg || "Échec de l'enregistrement."); }
    finally { setSaving(false); }
  };
  if (!brand) return <div className="text-sm text-text-cream/50 py-6"><Loader2 className="animate-spin inline mr-2" size={14}/>Chargement…</div>;
  const input = "w-full bg-black/40 border border-white/10 rounded px-3 py-2 text-sm focus:border-accent-deep outline-none";
  return (
    <div className="p-6 rounded-xl border border-accent-deep/30 bg-white/[0.03]" data-testid="brand-profile-form">
      <div className="grid md:grid-cols-2 gap-4">
        {FIELDS.map(([k, label, area]) => (
          <label key={k} className={area ? "md:col-span-2" : ""}>
            <span className="text-xs uppercase tracking-wider text-text-cream/50">{label}</span>
            {area
              ? <textarea rows={2} value={brand[k]} onChange={(e) => set(k, e.target.value)} className={`${input} mt-1`} data-testid={`brand-${k}`}/>
              : <input value={brand[k]} onChange={(e) => set(k, e.target.value)} className={`${input} mt-1`} data-testid={`brand-${k}`}/>}
          </label>
        ))}
        <label className="md:col-span-2">
          <span className="text-xs uppercase tracking-wider text-text-cream/50">Piliers de contenu (un par ligne)</span>
          <textarea rows={4} value={brand.pillars.join("\n")} onChange={(e) => set("pillars", e.target.value.split("\n"))}
            onBlur={() => set("pillars", brand.pillars.map((p) => p.trim()).filter(Boolean))} className={`${input} mt-1`} data-testid="brand-pillars"/>
        </label>
        <label>
          <span className="text-xs uppercase tracking-wider text-text-cream/50">Hashtags de base</span>
          <input value={brand.base_hashtags.join(" ")} onChange={(e) => set("base_hashtags", e.target.value.split(/\s+/).filter(Boolean))} className={`${input} mt-1`} data-testid="brand-hashtags"/>
        </label>
        <label>
          <span className="text-xs uppercase tracking-wider text-text-cream/50">Contenus par semaine (5 à 7)</span>
          <input type="number" min={5} max={7} value={brand.posts_per_week} onChange={(e) => set("posts_per_week", Number(e.target.value))} className={`${input} mt-1`} data-testid="brand-posts-per-week"/>
        </label>
      </div>
      <div className="mt-5 flex items-center gap-3">
        <button onClick={save} disabled={saving} className="btn btn-primary" data-testid="brand-save-btn">
          {saving ? <Loader2 className="animate-spin" size={14}/> : <Save size={14}/>} Enregistrer
        </button>
        <button onClick={onClose} className="text-sm text-text-cream/60 hover:text-text-cream" data-testid="brand-close-btn">Fermer</button>
        {msg && <span className="text-sm text-text-cream/70" data-testid="brand-save-msg">{msg}</span>}
      </div>
    </div>
  );
};
